import { Sheet } from '@/components/Sheet';
import { CallOverlay } from '@/components/chat/CallOverlay';
import type { useCallFlow } from '@/hooks/useCallFlow';

/**
 * Звонок с экрана «Звонки»: тот же путь, что из переписки (этап 2b): настройки телефонии → АТС
 * звонит на телефон человека → клиенту; без логина АТС / без АТС — объяснение и обычный звонок.
 */
export function CallLayer({ call, seed }: { call: ReturnType<typeof useCallFlow>; seed: number }) {
  return (
    <>
      {call.notice && (
        <Sheet label="Звонок" onClose={call.closeNotice}>
          <div className="sh"><h3>Позвонить</h3></div>
          <div className="sb">
            <p className="pnote" style={{ fontSize: 15, color: 'var(--fg)' }}>{call.notice.text}</p>
            <div className="btnrow">
              {call.notice.tel && <a className="primary" href={call.notice.tel} onClick={call.closeNotice}>Позвонить с телефона</a>}
              <button type="button" className="ghost" onClick={call.closeNotice}>Понятно</button>
            </div>
          </div>
        </Sheet>
      )}
      {call.ui && <CallOverlay call={call.ui} seed={seed} onClose={call.close} />}
    </>
  );
}

/** Число для цвета аватара из строки (id сделки/звонка). */
export function seedOf(s: string | null | undefined): number {
  let h = 0;
  for (const ch of s ?? '') h = (h * 31 + ch.charCodeAt(0)) | 0;
  return Math.abs(h);
}
